import o from "./ghl-ui.es803.js";
var e = o ? o.prototype : void 0, l = e ? e.valueOf : void 0;
function r(t) {
  return l ? Object(l.call(t)) : {};
}
export {
  r as default
};
